import { Helmet } from 'react-helmet-async';
import { Icon } from '@launchpad-ui/icons';

import { Subhead } from '../../shared';
import { useSettings } from '../../shared/hooks/useSettings';
import { useFavoriteActions, useFavorites } from '../hooks/useFavorites';
import { type Account, getAccountDisplayName } from '../model';

type AccountHeadingProps = {
  account: Account;
  includeHelmet?: boolean;
};

export function AccountHeading({ account, includeHelmet = true }: AccountHeadingProps) {
  const settings = useSettings();
  const favoritesQuery = useFavorites();
  const { addFavorite, removeFavorite } = useFavoriteActions();

  const displayName = getAccountDisplayName(account);
  const favorites = favoritesQuery.data || [];
  const isFavorited = favorites.some((fav) => fav.id === account._id);

  const handleStarClick = () => {
    const savedAccount = { id: account._id, displayName };
    if (isFavorited) {
      removeFavorite.mutate(savedAccount);
    } else {
      addFavorite.mutate(savedAccount);
    }
  };

  return (
    <>
      {includeHelmet && (
        <Helmet>
          <title>{`Account ${displayName}`}</title>
        </Helmet>
      )}
      <Subhead>
        {displayName}
        {settings.recentlyViewedAccounts && (
          <Icon
            className="star"
            name={isFavorited ? 'star' : 'star-outline'}
            size="large"
            style={{ cursor: 'pointer' }}
            onClick={handleStarClick}
          />
        )}
      </Subhead>
    </>
  );
}
